module.exports = __webpack_public_path__ + "img/availableColors.376a304.webp";